<template>
    <div>
        <div class="back-list page">
            <div class="list-head">
                <div>日期</div>
                <div>职级增减</div>
                <div>职级级别</div>
                <div>备注</div>
            </div>
            <z-scrollDiv class="main">
                <div class="list-item" v-for="item in dataList" :key="item.id">
                    <div>{{ item.bill_time | justDate }}</div>
                    <div :class="{add:item.bill_type == 1,reduce:item.bill_type!=1}">{{ item.amount && (item.bill_type==1?"+":"-")+item.amount }}</div>
                    <div>{{ item.balance }}</div>
                    <div class="overhide">{{ item.remark }}</div>
                </div>
                <z-noData :list="dataList"></z-noData>
            </z-scrollDiv>
        </div>

        <el-pagination
            @current-change="search"
            :current-page.sync="data.current_page"
            :total="data.total"
            :page-size="data.per_page"
            layout="prev, pager, next, jumper"
        ></el-pagination>

    </div>
</template>

<script>
    export default {
        props:['index','id'],
        data(){
            return {
                data:{},
            }
        },
        computed:{
            dataList(){
                return this.data.list;
            }
        },
        created(){
            this.fresh(this.index);
        },

        watch:{
            index(val){
                this.fresh(val);
            },
        },

        methods:{
            fresh(index){
                if(index == 2){
                    this.search(this.data.current_page);
                }
            },

            search(page){
                let obj = {
                    page:page,
                    user_id:this.id,
                }
                this.getData(obj);
            },

            getData(obj={}){
                let url = `api/admin/user/pmtlist`;
                this.$http.get(url,{params:obj}).then(res=>{
                    if(res.status ==200){
                        this.data = res.res_data;
                    }
                })
            },


        },
    }
</script>

<style lang="less" scoped>
    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 20%;
        }
        >div:nth-of-type(2){
            width: 20%;
        }
        >div:nth-of-type(3){
            width: 20%;
        }
        >div:last-of-type{
            width: 40%;
        }
        .add{
            color:#34b96c;
            // color:#43a2ff;
        }
        .reduce{
            color:#ff8383;
        }
    }
</style>





// WEBPACK FOOTER //
// person-rank.vue?c1a9b5da